import React from 'react'
import { GridCell, Grid } from 'common-controls/Core/index'

export function LayoutBody (props) {
  const { children, customLayout, blue, blockContainer = false, style = {} } = props
  const color = blue ? 'blue' : 'teal'
  let outerStyle = {}
  if (color === 'blue') {
    outerStyle.padding = '0px'
  }
  if (customLayout) {
    return <GridCell auto blockContainer={blockContainer} style={style} className={`slide-pane-content-${color}`}>
      {children}
    </GridCell>
  } else {
    return <GridCell auto blockContainer style={style} className={`slide-pane-content-${color}`}>
      <Grid>
        <GridCell small={12} blockY>
          <div className='wrapper'>
            {children}
          </div>
        </GridCell>
      </Grid>
    </GridCell>
  }
}

export default LayoutBody
